

export default class DatetimeInputs {
    static init(){

        const initializeDateInputs = () => {
            mobiscroll.localeFr.rangeStartLabel = 'Date de départ';
            mobiscroll.localeFr.rangeEndLabel = 'Date de retour';
            const today = new Date();
            const tomorow = new Date(today.getTime() + (24 * 60 * 60 * 1000));
        
            document.querySelectorAll('[data-rangepicker-date-from]').forEach((inputDateFrom) => {
                const id = inputDateFrom.dataset.rangepickerDateFrom;
                const inputDateTo = document.querySelector('[data-rangepicker-date-to="'+id+'"]')
                if(!inputDateTo) return;
        
                const inputTimeFrom = document.querySelector('[data-rangepicker-time-from="'+id+'"]')
                const inputTimeTo = document.querySelector('[data-rangepicker-time-to="'+id+'"]')
        
                const existingValues = [inputDateFrom.value, inputDateTo.value]
                const pages = window.outerWidth < 768 ? 1 : 2
        
                const rangeInput = mobiscroll.datepicker(inputDateFrom, {
                  controls: ['calendar'], //, 'timegrid'],
                  select: 'range',
                  theme: 'material',
                  themeVariant: 'light',
                  width: 600,
                  maxWidth: 600,
                  startInput: inputDateFrom,
                  endInput: inputDateTo,
                  pages: pages,
                  dateFormat: 'DD/MM/YYYY',
                  locale: mobiscroll.localeFr,
                  min: tomorow
                });
        
                rangeInput.setVal(existingValues)
            })
        }
        
        const initializeTimeInputs = () => {
          const timeInputs = document.querySelectorAll('.has-timepicker')
          const controls = window.outerWidth < 768 ? ['time'] : ['timegrid']
          timeInputs.forEach(function(item){
        
            mobiscroll.datepicker(item, {
              controls: controls,
              display: 'bubble',
              headerText: item.dataset.mbscHeaderText,
              theme: 'material',
              themeVariant: 'light',
              width: 400,
              maxWidth: 400,
              stepMinute: 15,
              timeFormat: 'HH:mm',
              timeWheels: 'HHmm',
              locale: mobiscroll.localeFr
            });
          })
        }
        
        initializeDateInputs()
        initializeTimeInputs()
        window.addEventListener('date-inputs-content-changed', event => {
          initializeDateInputs()
          initializeTimeInputs()
        });
    }
}

